import ContactInfo from "components/shared/contactInfo";
import { Field } from "components/shared/form";
import { ymEvent } from "helpers/system";
import React, { useState } from "react";
import { getByPhoneNumber } from "sources/columnDispatcher";
import { applyColumnDispatcher, resetCache } from "sources/tripPlanning";

const config = {
    name: {
        label: "ФИО колонного",
        inputProps: { name: "name" },
        bWrapper: "row form-group",
    },
    number: {
        label: "Телефон колонного",
        bWrapper: "row",
        inputProps: { name: "phoneNumber" },
    },
};

export default function ColumnDispatcherForm(props) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(props.columnDispatcher);

    const saveData = () => {
        setLoading(true);
        applyColumnDispatcher({ carId: props.carId, columnDispatcher: data }).then((res) => {
            if (res) {
                props.setColumnDispatcher(data);
                ymEvent("TripPlanningCarDetailsUsed");
                resetCache();
            }
            setLoading(false);
            props.back();
        });
    };

    const deleteData = () => {
        setLoading(true);
        applyColumnDispatcher({ carId: props.carId, mechanic: null }).then((res) => {
            if (res) {
                props.setColumnDispatcher(null);
                ymEvent("TripPlanningCarDetailsUsed");
                resetCache();
            }
            setLoading(false);
            props.back();
        });
    };

    const changeHandle = ({ value }) => setData({ ...data, ...value });

    const renderField = (fieldProps) => <Field {...fieldProps} />;

    return (
        <div className={loading ? "loading" : ""}>
            <ContactInfo
                {...{
                    renderField,
                    contact: data,
                    setValue: changeHandle,
                    config,
                    getContactInfo: getByPhoneNumber,
                    fieldName: "columnDispatcher",
                }}
            />
            <div className="d-flex justify-content-between mt-2">
                {props.columnDispatcher ? (
                    <div className="btn btn-outline-danger" onClick={deleteData}>
                        Удалить
                    </div>
                ) : (
                    <div />
                )}
                <div className="btn btn-brand" onClick={saveData}>
                    Сохранить
                </div>
            </div>
        </div>
    );
}
